/**
 * 普通日期格式化
 * @param {*} time 需要格式化的日期
 * @param {*} format 需要转换成的时间格式 'yyyy-MM-dd HH:mm:ss' / 'yyyy-MM-dd'
 */
export const timeFormat = (time, format) => {
    let year= new Date(time).getFullYear()
    let month= new Date(time).getMonth()+1
    let date= new Date(time).getDate()
    if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }

    return year +'年' + month +'月'+ date + '日'
}


// WEBPACK FOOTER //
// ./src/utils/common.js